var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-content container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [(!_vm.isEdit) ? _c('div', {
    staticClass: "user-details",
    attrs: {
      "id": "displayprofile"
    }
  }, [_c('div', {
    staticClass: "pic"
  }, [(_vm.basicProfile.profileImg != '') ? _c('div', {
    staticClass: "img-edit",
    attrs: {
      "id": "image"
    }
  }, [_c('b-tooltip', {
    attrs: {
      "target": "image",
      "title": "Edit profile"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.basicProfile.profileImg,
      "width": "200",
      "height": "200"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-edit",
    on: {
      "click": _vm.editBasicProfile
    }
  }, [_c('i', {
    staticClass: "mdi mdi-pencil"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.basicProfile.profileImg == '') ? _c('div', {
    staticClass: "img-edit",
    attrs: {
      "id": "image"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/images/user.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('button', {
    staticClass: "btn btn-edit",
    on: {
      "click": _vm.editBasicProfile
    }
  }, [_c('i', {
    staticClass: "mdi mdi-pencil"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.basicProfile.profileImg != '') ? _c('div', [_c('button', {
    staticClass: "btn btn-danger btn-block text-center",
    on: {
      "click": function($event) {
        _vm.DeleteFile(_vm.basicProfile.profileImg)
      }
    }
  }, [_vm._v("Remove Profile Picture")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', [_vm._v(_vm._s(_vm.basicProfile.fullName) + " ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.contact')) + " :")]), _vm._v(" "), _vm._l((_vm.basicProfile.accountDetails), function(accountInfo, index) {
    return _c('div', {
      key: index
    }, [_c('div', [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.AccountType')) + " : ")]), _vm._v(_vm._s(accountInfo.jvId))]), _c('br'), _vm._v(" "), (accountInfo.email != undefined && accountInfo.email != null && accountInfo.email.length > 0) ? _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.$t('profileDetails.placeholder.email')) + " : ")]), _vm._v(_vm._s(accountInfo.email))]) : _vm._e(), (accountInfo.email != undefined && accountInfo.email.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), (accountInfo.mobile != undefined && accountInfo.mobile != null && accountInfo.mobile.length > 0) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.mobile')) + "  : ")]), _vm._v(_vm._s(accountInfo.mobile))]) : _vm._e(), (accountInfo.mobile != undefined && accountInfo.mobile.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), (accountInfo.portedUserName != undefined && accountInfo.portedUserName != null && accountInfo.portedUserName.length > 0) ? _c('span', [_c('b', [_vm._v("Username : ")]), _vm._v(_vm._s(accountInfo.portedUserName))]) : _vm._e(), (accountInfo.portedUserName.length != undefined && accountInfo.portedUserName.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), (index + 1 < _vm.basicProfile.accountDetails.length) ? _c('br') : _vm._e()]), _vm._v(" "), (index + 1 === _vm.basicProfile.accountDetails.length) ? _c('hr') : _vm._e()])
  })], 2), _vm._v(" "), (_vm.$store.getters.getProfileDetails.mobile != undefined && _vm.$store.getters.getProfileDetails.mobile != null) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("Contact")]), _vm._v(" "), (_vm.$store.getters.getProfileDetails.mobile.length !== 0) ? _c('span', [_vm._v(_vm._s(_vm.$store.getters.getProfileDetails.mobile))]) : _c('span', [_vm._v("Add contact details")])]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.skills != undefined && _vm.skills != null && _vm.skills.length > 0) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("skills")]), _vm._v(" "), _vm._l((_vm.skills), function(skill, i) {
    return _c('div', {
      key: i
    }, [_c('span', [_vm._v(_vm._s(skill))])])
  }), _vm._v(" "), _c('hr')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.aboutMe')))]), _vm._v(" "), (_vm.basicProfile.aboutMe == '') ? _c('span', [_vm._v(_vm._s(_vm.$t('profileDetails.labels.Hi_I_am')) + " " + _vm._s(_vm.basicProfile.fullName))]) : _c('span', [_vm._v(_vm._s(_vm.basicProfile.aboutMe))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blue btn-block",
    on: {
      "click": _vm.editBasicProfile
    }
  }, [_vm._v("\r\n               " + _vm._s(_vm.$t('profileDetails.labels.editButtonText')))])]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-details",
    attrs: {
      "id": "editprofile"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "col-md-12 upload-pic"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("Your Profile Picture")]), _vm._v(" "), _c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "guides": true,
      "view-mode": 2,
      "drag-mode": "crop",
      "auto-crop-area": 1,
      "min-container-width": 150,
      "min-container-height": 80,
      "background": true,
      "rotatable": true,
      "src": _vm.getImageSrc(),
      "img-style": {
        'width': '300px',
        'height': '200px'
      }
    }
  }), _vm._v(" "), (_vm.fileExceedLimit) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('b', [_vm._v(" Image size should be less than " + _vm._s(_vm.maxFilesize * 1000) + " kb")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.imgSrc != '') ? _c('button', {
    staticClass: "btn btn-blue ",
    attrs: {
      "disabled": _vm.fileExceedLimit
    },
    on: {
      "click": _vm.cropImage
    }
  }, [_vm._v("Crop")]) : _vm._e(), _vm._v(" "), (_vm.imgSrc != '') ? _c('button', {
    staticClass: "btn btn-blue ",
    attrs: {
      "disabled": _vm.fileExceedLimit
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("Upload")]) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_c('span', [_vm._v("Select new profile image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "font-size": "1.2em",
      "padding": "10px 0"
    },
    attrs: {
      "type": "file",
      "name": "image",
      "id": "imgUpload",
      "accept": "image/*"
    },
    on: {
      "change": _vm.setImage
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.yourName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_name),
      expression: "in_name"
    }],
    ref: "name",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": _vm.$t('profileDetails.placeholder.YourFullName'),
      "value": "Neha Sharma"
    },
    domProps: {
      "value": (_vm.in_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.in_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.$store.getters.getProfileDetails.mobile != undefined && _vm.$store.getters.getProfileDetails.mobile != null && _vm.$store.getters.getProfileDetails.mobile.length == 0) ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.contact')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "placeholder": _vm.$store.getters.getProfileDetails.mobile.length === 0 ? 'Enter contact details' : ''
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topic"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.aboutMe')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.in_aboutMe),
      expression: "in_aboutMe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "3",
      "placeholder": _vm.$t('profileDetails.placeholder.WriteAboutYourself')
    },
    domProps: {
      "value": (_vm.in_aboutMe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.in_aboutMe = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blue btn-block",
    on: {
      "click": _vm.saveBasicProfile
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.saveButtonText')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "card-tabs"
  }, [_c('div', {
    staticClass: "tabs-css"
  }, [_c('b-tabs', [_c('hr'), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('profileDetails.labels.PurchasedCourses')
    }
  }, [_vm._l((_vm.enrolledCourses), function(course, i) {
    return _c('div', {
      key: i,
      staticClass: "card-design card-design-profile"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [(_vm.checkValue(course.thumbnail)) ? _c('div', [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": _vm.makePath(course.thumbnail),
        "alt": ""
      }
    })]) : _c('div', [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": require("../../../static/assets/images/defaultCO.jpg"),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 align-self-center"
    }, [_c('h5', {
      staticClass: "card-design__data-heading",
      on: {
        "click": function($event) {
          _vm.learnCourse(course)
        }
      }
    }, [_vm._v(_vm._s(course.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("\r\n                                      " + _vm._s(_vm.$t('profileDetails.labels.Course_starts_on')) + " "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(course.purchasedDate, "Do MMM, YYYY ")))]), _vm._v("\r\n                                      " + _vm._s(_vm.$t('profileDetails.labels.and_expires_on'))), _c('span', [_vm._v(_vm._s(_vm._f("moment")(course.expiryDate, "Do MMM, YYYY ")))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-design__details"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__metadata"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('profileDetails.labels.You\'ve_solved')) + " "), _c('strong', [_vm._v(_vm._s(course.allocationDetails == undefined ? 0 : course.allocationDetails.solvedChallengeCount))]), _vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.challenges')) + " ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.and_completed')) + " "), _c('strong', [_vm._v(" " + _vm._s(course.allocationDetails == undefined ? 0 : course.allocationDetails.completedAggregationCount) + " ")]), _vm._v(_vm._s(_vm.$t('profileDetails.labels.lectures')) + " ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.out_of')) + " "), _c('strong', [_vm._v(" " + _vm._s(course.allocationDetails == undefined ? 0 : course.allocationDetails.courseMetadata.totalAggregations) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("Course costs " + _vm._s(course.price) + " " + _vm._s(course.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row card-design__data-ratings"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "col"
    }, [_c('span', {
      staticClass: "ratingText"
    }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.My_Rating')) + " ")]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "rating": course.rating,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      },
      on: {
        "rating-selected": _vm.setRating
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('share-on-media', {
      attrs: {
        "item": course,
        "labelOnTop": false
      }
    })], 1)])])])])])
  }), _vm._v(" "), (_vm.enrolledCourses.length == 0) ? _c('div', [_c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('course.noCourses')) + "\r\n                               "), _c('router-link', {
    staticClass: "linkcss",
    attrs: {
      "to": "home"
    }
  }, [_vm._v("courses!")])], 1)])]) : _vm._e()], 2), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('profileDetails.labels.PurchasedVideos')
    }
  }, [_vm._l((_vm.$store.getters.getUserSingleConceptsCollection), function(lo, j) {
    return _c('div', {
      key: j,
      staticClass: "card-design card-design-profile"
    }, [_c('div', {
      staticClass: "row"
    }, [(_vm.checkValue(lo.thumbnail)) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": _vm.makePath(lo.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": require("../../../static/assets/images/defaultLO.jpg"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 align-self-center"
    }, [_c('h5', {
      staticClass: "card-design__data-heading no-line",
      on: {
        "click": function($event) {
          _vm.learnLO(lo)
        }
      }
    }, [_vm._v(_vm._s(lo.title))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__details"
    }, [_c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("\r\n                                          " + _vm._s(_vm.$t('profileDetails.labels.item_purchased_on')) + "\r\n                                            "), _c('span', [_vm._v(" " + _vm._s(_vm._f("moment")(lo.purchasedDate, "Do MMM, YYYY ")) + " ")]), _vm._v(" "), _vm._v("\r\n                                            " + _vm._s(_vm.$t('profileDetails.labels.item_expires_on')) + "\r\n                                            "), _c('span', [_vm._v(" " + _vm._s(_vm._f("moment")(lo.expiryDate, "Do MMM, YYYY ")) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-cost"
    }, [_vm._v("Single concept costs " + _vm._s(lo.price) + " " + _vm._s(lo.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (lo.courseType === 'LO') ? _c('div', {
      on: {
        "click": function($event) {
          _vm.showRating(lo.contentId)
        }
      }
    }, [_c('br'), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('span', {
      staticClass: "ratingText"
    }, [_vm._v(" Your Rating ")]) : _vm._e(), _vm._v(" "), _c('star-rating', {
      attrs: {
        "rating": lo.rating,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      },
      on: {
        "rating-selected": _vm.setRating
      }
    })], 1) : _vm._e()])])])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-blue",
    staticStyle: {
      "text-color": "#eee"
    },
    attrs: {
      "to": "playlist"
    }
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.placeholder.SeeMore')))]), _vm._v(" "), (_vm.enrolledLOs.length == 0) ? _c('div', [_c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('profileDetails.labels.noLO')) + "\r\n                               "), _c('router-link', {
    staticClass: "linkcss",
    attrs: {
      "to": "home"
    }
  }, [_vm._v(" concepts! ")])], 1)])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-tab', {
    attrs: {
      "title": _vm.$t('profileDetails.labels.Playlist')
    }
  }, [_vm._l((_vm.playLists), function(playlist) {
    return (!playlist.isWishList) ? _c('div', {
      key: playlist.plId,
      staticClass: "card-design card-design-profile"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-fluid card-design__img",
      attrs: {
        "src": require("../../../static/assets/images/defaultLO.jpg"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 align-self-center"
    }, [_c('h5', {
      staticClass: "card-design__data-heading"
    }, [_vm._v(_vm._s(playlist.plName))]), _vm._v(" "), _c('div', {
      staticClass: "card-design__details"
    }, [((playlist.items.length <= 1)) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('No. of Concept')))]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(playlist.items.length))])]) : _c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('No. of Concepts')))]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(playlist.items.length))])])]), _vm._v(" "), (playlist.items.length == 0) ? _c('div', {
      staticClass: "action-btn"
    }, [_c('button', {
      staticClass: "btn btn-blue",
      on: {
        "click": _vm.goToPlaylist
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.watchButtonText')))])]) : _c('div', {
      staticClass: "action-btn"
    }, [_c('button', {
      staticClass: "btn btn-blue",
      on: {
        "click": function($event) {
          _vm.goToContentViewer(playlist)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('profileDetails.labels.watchButtonText')))])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.playLists.length == 0) ? _c('div', [_c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v("\r\n                                 " + _vm._s(_vm.$t('playlist.noPlaylists')) + "\r\n                                 "), _c('router-link', {
    staticClass: "linkcss",
    attrs: {
      "to": "playlist"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.now')) + "!")])], 1)])]) : _vm._e()], 2) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === true),
      expression: "loading===true"
    }],
    staticClass: "loader-wraper"
  }, [_c('div', {
    staticClass: "loader-box"
  }, [_vm._m(0), _vm._v(" "), _c('h6', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$t('profileDetails.labels.PleaseWait')))])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-roller"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48835813","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/profileContent.vue
// module id = IfgM
// module chunks = 1